import type { GetRecommendationsParams } from '@libs/common-types';

export const CWEA_ENDPOINTS = {
    account: {
        anonymousId: `account/anonymousId`,
    },
    cart: {
        fetchVetAuthImage: (cartId?: string, imageId?: string) =>
            `carts/${cartId}/items/vetAuth/${imageId}`,
        uploadVetAuthImage: (cartId?: string, itemId?: string) =>
            `carts/${cartId}/items/${itemId}/vetAuth`,
    },
    customerCare: {
        contactUs: `customerCare/contactUs`,
    },
    loyalty: {
        activateOffer: `loyalty/activateOffer`,
        getLoyaltyPoints: `loyalty/points`,
        getOffers: `loyalty/getLoyaltyOffers`,
        getMemberPoints: `loyalty/getMemberPoints`,
        getPointsHistory: `loyalty/pointsHistory`,
    },
    inventory: {
        getProductInventory: (sku: string) => `inventory/${sku}`,
        getProductInventoryPairs: `inventory`,
    },
    recommendations: {
        getProductRecommendations: ({
            productId,
            customerId,
            storeId,
            locale,
        }: GetRecommendationsParams) =>
            `recommendations/customer/${customerId}/product/${productId}/store/${storeId}/locale/${locale}`,
    },
    stores: {
        getStoreById: (storeId: string) => `stores/${storeId}`,
    },
    discounts: {
        getDiscountDetails: (key: string) => `discounts/${key}/details`,
    },
};

export const IDENTITY_ENDPOINTS = {
    consumeExchangeToken: 'v2/authentication/consumeExchangeToken',
    createExchangeToken: 'authentication/createExchangeToken',
};
